var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VisualHeader"},[_c('h1',{staticClass:"VisualHeader-title"},[_vm._v("可视化面板--V1")])])}]

export { render, staticRenderFns }